module.exports = __webpack_public_path__ + "img/regent-seven.147fa07f.jpg";